import { createAsyncThunk } from '@reduxjs/toolkit';


import type { ApiPointsFetchParamsType } from 'constants/apiPoints';


import authorizationThunk from 'redux-store/thunks/profile/authorizationThunk';

import doFetch from 'utils/doFetch';

const registrationThunk = createAsyncThunk(
  'profile/registration',
  async (
    {
      email,
      password,
      username,
    }: ApiPointsFetchParamsType['registration']['request'],
    thunkAPI,
  ) => {
    try {
      const apiPointName = 'registration';
      const result = await doFetch<typeof apiPointName>({
        apiPointName,
        body: { email, password, username },
      });

      if (result.success) {

        thunkAPI.dispatch(
          authorizationThunk({ email: email.trim(), password: password.trim() }),
        );
      }
      else {
        throw result.error ? result.error : 'Registration failed';
      }

      return result;
    }
    catch (error: any) {
      throw error;
    }
  },
);

export default registrationThunk;
